<template>
	<button class="type-button" :class="className" :style="styleText" @click="$emit('click', $event)">
		<slot>
			行动按钮
		</slot>
	</button>
</template>

<script>
	export default {
		name: 'type-button',
		props: {
			size: {
				type: String, // max-title 1、 title 3、 subtitle 9、 content button input 6、 min-content 9
				default: '6',
				validator: value => [ '1', '2', '3', '4', '5', '6', '7', '8', '9' ].indexOf(String(value)) > -1
			},
			round: {
				type: Boolean,
				default: false
			},
			weight: {
				type: String,
				default: '300'
			},
			height: {
				type: String,
				default: '46px'
			},
			padding: {
				type: String,
				default: '0 20px'
			},
			border: {
				type: Boolean,
				default: false
			},
			whitebackdrop: {
				type: Boolean,
				default: false
			}
		},
		computed: {
			className() {
				let name = `button-text text-content-${this.size}`;
				if (this.border) {
					return name + (this.whitebackdrop ? ' border-white-backdrop' : ' border-other-backdrop');
				}
				return name + (this.whitebackdrop ? ' white-backdrop' : ' other-backdrop');
			},
			styleText() {
				let text = `font-weight: ${this.weight};`;
				if (this.round) {
					text += `border-radius: 50vw;`;
				}
				if (this.border === false) {
					text += `height: ${this.height};padding: ${this.padding};`;
				}
				return text;
			}
		}
	}
</script>

<style scoped lang="less">
	.type-button{
		border: none;
		outline: none;
		cursor: pointer;
		overflow: hidden;
		position: relative;
		background-color: transparent;
		transition: all 300ms ease-in-out;
		font-family: 'Montserrat', sans-serif;
		&:hover{
			opacity: 0.8;
		}
		&::after{
			content: '';
			display: block;
			position: absolute;
			height: 100vw;
			width: 100vw;
			top: 50%;
			left: 50%;
			border: none;
			outline: none;
			border-radius: 50%;
			pointer-events: none;
			background-repeat: no-repeat;
			background-position: 50%;
			opacity: 0;
			transition: transform 1.8s ease, opacity 2.2s linear;
			transform: translate(-50%, -50%) scale(2);
		}
		&:active{
			&::after{
				opacity: .5;
				transition: 0s;
				transform: translate(-50%, -50%) scale(0);
			}
		}
	}
	.white-backdrop{
		color: #000000;
		&::after{
			background-image: radial-gradient(circle, rgba(153, 153, 153, 0.5) 50%, transparent 50%);
		}
	}
	.other-backdrop{
		color: #FFFFFF;
		&::after{
			background-image: radial-gradient(circle, rgba(255, 255, 255, 0.5) 50%, transparent 50%);
		}
	}
	.border-white-backdrop, .border-other-backdrop{
		width: 100%;
		padding: 0;
		height: 46px;
		border-width: 2px;
		border-style: solid;
	}
	.border-white-backdrop{
		color: #000000;
		border-color: #888888;
		&:hover{
			color: #FFFFFF;
			background-color: #888888;
		}
		&::after{
			background-image: radial-gradient(circle, rgba(255, 255, 255, 0.5) 50%, transparent 50%);
		}
	}
	.border-other-backdrop{
		color: #FFFFFF;
		border-color: #FFFFFF;
		&:hover{
			color: #000000;
			background-color: #FFFFFF;
		}
		&::after{
			background-image: radial-gradient(circle, rgba(153, 153, 153, 0.5) 50%, transparent 50%);
		}
	}
</style>
